<!-- 联系我们 -->
<template>
  <transition name="el-fade-in-linear">
      <div id="AboutUs">
    <headerVue></headerVue>
    <div class="container">
      <!-- <div class="title">联系我们</div> -->
      <div class="content">
        <div class="left">
          <p>地址：{{ basicInfo.address }}</p>
          <p>邮政编码：{{ basicInfo.zipCode }}</p>
          <p>电话：{{ basicInfo.phone }}</p>
          <p>传真：{{ basicInfo.fax }}</p>
        </div>
        <div class="right">
          <img src="../../assets/image/picture/map.png" alt="">
        </div>
      </div>
      <div class="bottom" v-if="false">
        <p>办公室：63903365 <span>|</span> 63903378 <span>|</span> 63903380（传真）<span>|</span> 63903383 <span>|</span>	63903345</p>
        <p>组织部：63903370 <span>|</span> 63903380</p>
        <p>宣传部：63903372 <span>|</span> 63903385</p>
        <p>参政议政部：63903368 <span>|</span> 63903385</p>
        <p>社会服务部：63903371 <span>|</span> 63903374</p>
      </div>
    </div>
    <footerVue></footerVue>
  </div>
  </transition>

</template>

<script>
import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'
export default {
  name: 'AboutUs',
  data() {
    return {
      basicInfo: [],
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      let res = await this.$api.nav.getFooterInfo()
      // console.log('rrrrrrrrrrres',res);
      this.basicInfo = res.data.siteBaseInfo
      // console.log('基本信息',this.basicInfo);
    }
  },
  components: {
    headerVue,
    footerVue
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: auto;
  background-color: white;
  margin-top: 20px;

  .title {
    padding: 10px;
    padding-bottom: 20px;
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
  }

  .content {
    height: 360px;
    display: flex;
    justify-content: space-between;
    width: 1000px;
    background-color: #3282D2;
    margin: auto;
    margin-bottom: 20px;
    margin-top: 30px;
    .left{
      margin: auto;
      text-align: center;
      line-height: 60px;
      flex:1;
      p{
        color:white;
        font-size: 16px;
      }
    }
    .right {
      flex:1;
      img {
        width: 600px;
      }
    }
  }
  .bottom{
    width: 1000px;
    margin: auto;
    text-align: left;
    p{
      font-size: 17px;
      line-height: 35px;
      color:#3C3C3C;
    }
    span{
      color:#999999;
      font-weight: lighter;
      padding: 5px;
    }
  }
}
.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
</style>